/**
 * CarouselOnSlid
 *
 * modul slouží ke spuštění kódu při najetí položky carouselu
 *
 * hledá se atribut data-on-slid na konkrétním .carousel-item
 *
 * data-on-slid="window.dataLayer.push({....})"
 *
 * pro použití a spuštění stačí vložit do index.js řádku:
 * import "./js/Spinao/CarouselOnSlid";
 */

function processSlide(carouselItem)
{
    console.log('GTAG-D');
    if(carouselItem.dataset.onSlid) {
        console.log('GTAG-E');
        eval(carouselItem.dataset.onSlid);
    }
}

document.addEventListener("DOMContentLoaded", function() {
    console.log('GTAG-A');
    document.querySelectorAll('.carousel-item.active').forEach(function(item) {
        console.log('GTAG-B');
        processSlide(item);
    });

    document.addEventListener('slid.bs.carousel', function(event) {
        console.log('GTAG-C');
        if (typeof gtag === "function") {
            let active = event.target.querySelector('.carousel-item.active');
            processSlide(active);
        }
    });
});
